import $ from 'jquery';
import Swiper from 'swiper';
import QuickAdd from '../global/QuickAdd';
import Section from '../Section';

function get_unique_array(array) {
  var newArray = new Array();
  var handleArray = new Array();

  for (var i = 0; i < array.length; i++) {
    var handle = array[i]['handle'];
    if (handleArray.indexOf(handle) === -1) {
      newArray.push(array[i]);
      handleArray.push(handle);
    }
  }
  return newArray;
}

export default class RecentlyViewed extends Section {
  RECENTLY_VIEWED_COUNT = 10;
  RECENTLY_VIEWED_LOCAL_STORAGE_KEY = 'recentlyVisited';
  PLACEHOLDER = 'PLACEHOLDER';

  /**
   * @param {import('../ThemeBase').default} theme
   * @param {HTMLElement} element
   */
  constructor(theme, element, pageLoad) {
    super(theme, element, pageLoad);

    this.$element = $(element);
    this.handle = this.element.dataset.productHandle;
    this.productUrl = this.element.dataset.productUrl;
    this.blocksArray = this.element.dataset.blocks.split(',');
    this.$content = this.$element.find('#recently-viewed-products');

    if (this.$content.hasClass('recently-viewed-loading')) {
      return;
    }

    this.$content.empty().addClass('recently-viewed-loading');

    var recentlyViewedJSON = null;

    if (this._isLocalStorageSupported()) {
      recentlyViewedJSON = localStorage.getItem(this.RECENTLY_VIEWED_LOCAL_STORAGE_KEY);
    }

    var recentlyViewed = recentlyViewedJSON != null ? JSON.parse(recentlyViewedJSON) : [];

    if (this.handle) {
      var item = {
        'handle': this.handle,
      };
      recentlyViewed.unshift(item);
    }

    var uniqueArray = recentlyViewed.length ? get_unique_array(recentlyViewed) : recentlyViewed;
    if (uniqueArray.length > this.RECENTLY_VIEWED_COUNT) {
      uniqueArray = uniqueArray.slice(0, this.RECENTLY_VIEWED_COUNT);
    }

    if (this._isLocalStorageSupported()) {
      localStorage.setItem(this.RECENTLY_VIEWED_LOCAL_STORAGE_KEY, JSON.stringify(uniqueArray));
    }

    if (uniqueArray.length > 1 || (uniqueArray.length === 1 && uniqueArray[0]['handle'] !== this.handle)) {
      this.loadProducts(uniqueArray.filter((item) => { return item.handle !== this.handle }));
    } else {
      this.$element.remove();
    }

    var self = this;
    window.addEventListener('load', (event) => {
      this.quickAddButtons = new QuickAdd(theme, element);
      setTimeout(() => {
        if(self.swiper) {
          self.swiper.resize.resizeHandler();
        }
      }, 1000);
    });

    document.addEventListener('quickadd:buttons:added', () => {
      this.handleProductCardDisplay();
      document.addEventListener('shopify:section:load', this.handleProductCardDisplay);
      window.addEventListener('resize', this.handleProductCardDisplay);
    });
  }

  loadProducts = (recentlyViewed) => {
    let str = this.paramStr(this.blocksArray);

    var promises = recentlyViewed.map(function (rv) {
      return $.get(this.productUrl.replace(this.PLACEHOLDER, rv.handle), { blocks: str });
    }.bind(this));

    $.when.apply($, promises)
      .then(() => {
        let allOK = true;

        promises.forEach((promise) => {
          if (promise.status === 200) {
            var container = document.createElement('div');
            container.innerHTML = promise.responseText;

            this.$content.append(
              container.querySelector('.main-content .grid__item').outerHTML
            );

            this.$content.find('.grid__item').addClass('swiper-slide');
            this.orderBlocks(container.querySelector('.grid-view-item'));

          } else {
            console.warn('Unable to fetch recently visited product: ', promise.status, promise.responseText);
            allOK = false;
          }
        });

        if (allOK) {
          this.show();
        }
        else {
          this.hideButtons();
        }
      });
  }

  orderBlocks = (parent) => {
    if(!this.blocksArray) return;

    const clone = parent.cloneNode(true);
    parent.innerHTML = '';

    this.blocksArray.forEach((block) => {
      if (!block) return;
      const blockElement = clone.querySelector(`[data-block-type=${block}]`);
      if (blockElement) {
        parent.appendChild(blockElement);
      }
    });
  }

  hideButtons = () => {
    this.$element.find('.swiper-button--next').hide();
    this.$element.find('.swiper-button--prev').hide();
  }

  show = () => {
    const nextEl = this.element.querySelector('.swiper-button--next');
    const prevEl = this.element.querySelector('.swiper-button--prev');
    this.$element.fadeIn();
    this.swiper = new Swiper(this.element.querySelector('.swiper-container'), {
      slidesPerView: 2,
      navigation: {
        nextEl,
        prevEl,
      },
      breakpoints: {
        768: {
          slidesPerView: 4,
        },
      },
      watchOverflow: true,
      autoHeight: true,
    });

    this.loadShopNow();
    this.badge = this.theme.addBadges(this.element, 1000);
  }

  loadShopNow = () => {
    if (this.element.dataset.quickShop === 'true') {
      // it was not added in liquid as we cannot access this section settings, we have to add it manually
      Array.prototype.forEach.call(
        this.element.querySelectorAll('.grid-view-item'),
        (el) => {
          const title = el.querySelector('.product-grid--title');
          const imgWrapper = el.querySelector('.grid-view-item-image');
          const descWrapper = el.querySelector('.grid-view-item--desc-wrapper');

          const a = document.createElement('a');
          a.classList.add('shop-now-button');
          a.href = title.querySelector('a').href;
          a.textContent = this.theme.translations.quick_shop;
          a.addEventListener('click', this.handleShopNow);

          const wrapper = document.createElement('div');
          wrapper.appendChild(a);
          wrapper.classList.add('shop-now-wrapper');

          const desktopShopNow = wrapper;
          const mobileShopNow = /** @type {HTMLInputElement} */ (wrapper.cloneNode(true));

          desktopShopNow.classList.add('shop-now-wrapper--desktop');
          mobileShopNow.classList.add('shop-now-wrapper--mobile');

          imgWrapper.appendChild(desktopShopNow);
          descWrapper.parentNode.insertBefore(mobileShopNow, descWrapper.nextSibling);
        }
      )
    }


    if (this.element.dataset.quickAdd === 'true') {
      Array.prototype.forEach.call(
        this.element.querySelectorAll('.grid-view-item'),
        (el) => {
          const productId = Number(el.dataset.productId);
          const productAvailable = (el.dataset.productAvailable == 'true');
          const productVarSize = Number(el.dataset.productVariantsSize);
          const quickShopMobileEnabled = (el.closest('[data-wetheme-section-type="template--product--recently-viewed"').dataset.quickShopMobileDisabled == 'false');
          const product_url = el.dataset.productUrl;
          const cardImageBottomWrapper = el.querySelector('.product-card-image--bottom-wrapper');

          // Construct button for this product.
          const a_desktop = document.createElement('a');
          const a_mobile = document.createElement('a');
          const wrapper = document.createElement('div');
          wrapper.classList.add('quick-add-wrapper');
          if(productVarSize == 1) wrapper.classList.add('is-singular');

          if(productVarSize > 1 && productAvailable) {
            // Desktop button.
            a_desktop.classList.add('quick-add-button-variants', 'quick-add-button-variants-desktop');
            a_desktop.tabIndex = 0;
            a_desktop.href = product_url;
            a_desktop.textContent = this.theme.translations.view_options;
            a_desktop.addEventListener('click', this.handleShopNow);

            // Mobile button.
            a_mobile.classList.add('quick-add-button-variants', 'quick-add-button-variants-mobile');
            if (quickShopMobileEnabled == false) a_mobile.classList.add('quick-shop-hidden');

            a_mobile.tabIndex = 0;
            a_mobile.href = product_url;

            const icon_span = document.createElement('span');
            icon_span.innerHTML = `<svg viewBox="0 0 24 24" width="16" height="16" fill="none" xmlns="http://www.w3.org/2000/svg" class="quick-view-mobile-icon"><path d="M14.0003 5C14.0003 4.46957 13.7896 3.96086 13.4145 3.58579C13.0395 3.21071 12.5308 3 12.0003 3C11.4699 3 10.9612 3.21071 10.5861 3.58579C10.211 3.96086 10.0003 4.46957 10.0003 5M19.2603 9.696L20.6453 18.696C20.6891 18.9808 20.6709 19.2718 20.5917 19.5489C20.5126 19.8261 20.3746 20.0828 20.187 20.3016C19.9995 20.5204 19.7668 20.6961 19.505 20.8167C19.2433 20.9372 18.9585 20.9997 18.6703 21H5.33032C5.04195 21 4.75699 20.9377 4.49496 20.8173C4.23294 20.6969 4.00005 20.5212 3.81226 20.3024C3.62448 20.0836 3.48624 19.8267 3.40702 19.5494C3.32781 19.2721 3.30949 18.981 3.35332 18.696L4.73832 9.696C4.81097 9.22359 5.0504 8.79282 5.41324 8.4817C5.77609 8.17059 6.23835 7.9997 6.71632 8H17.2843C17.7621 7.99994 18.2241 8.17094 18.5868 8.48203C18.9494 8.79312 19.1877 9.22376 19.2603 9.696Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
            a_mobile.appendChild(icon_span);
            a_mobile.addEventListener('click', this.handleShopNow);

            [a_desktop, a_mobile].forEach((a) => {
              wrapper.appendChild(a);
            });
          }
          else if(productAvailable) {
            // HTML Form. Used for the 'Add to cart' button functionality.
            const form = document.createElement('form');
            form.method = 'post';
            form.action = '/cart/add';
            form.id = 'CollectionAddToCartForm';
            form.acceptCharset = 'UTF-8';
            form.classList.add('shopify-product-form');
            form.enctype = 'multipart/form-data';
            // Hidden form inputs.
            const form_type = document.createElement('input');
            form_type.type = 'hidden';
            form_type.name = 'form_type';
            form_type.value = 'product';
            form.appendChild(form_type);
            const utf_input = document.createElement('input');
            utf_input.type = 'hidden';
            utf_input.name = 'utf8';
            utf_input.value = '✓';
            form.appendChild(utf_input);
            const prod_id = document.createElement('input');
            prod_id.type = 'hidden';
            prod_id.name = 'id';
            prod_id.value = productId.toString();
            form.appendChild(prod_id);

            // Submit button desktop.
            const btn_desktop = document.createElement('button');
            btn_desktop.classList.add('quick-add-button', 'quick-add-button-desktop');
            btn_desktop.type = 'submit';
            btn_desktop.tabIndex = 0;
            btn_desktop.textContent = this.theme.translations.addToCart;

            // Submit button mobile.
            const btn_mobile = document.createElement('button');
            btn_mobile.classList.add('quick-add-button', 'quick-add-button-mobile');
            if (quickShopMobileEnabled == false) btn_mobile.classList.add('quick-shop-hidden');

            btn_mobile.type = 'submit';
            btn_mobile.tabIndex = 0;

            const icon_span = document.createElement('span');
            icon_span.innerHTML = `<svg viewBox="0 0 24 24" width="16" height="16" fill="none" xmlns="http://www.w3.org/2000/svg" class="quick-view-mobile-icon"><path d="M14.0003 5C14.0003 4.46957 13.7896 3.96086 13.4145 3.58579C13.0395 3.21071 12.5308 3 12.0003 3C11.4699 3 10.9612 3.21071 10.5861 3.58579C10.211 3.96086 10.0003 4.46957 10.0003 5M19.2603 9.696L20.6453 18.696C20.6891 18.9808 20.6709 19.2718 20.5917 19.5489C20.5126 19.8261 20.3746 20.0828 20.187 20.3016C19.9995 20.5204 19.7668 20.6961 19.505 20.8167C19.2433 20.9372 18.9585 20.9997 18.6703 21H5.33032C5.04195 21 4.75699 20.9377 4.49496 20.8173C4.23294 20.6969 4.00005 20.5212 3.81226 20.3024C3.62448 20.0836 3.48624 19.8267 3.40702 19.5494C3.32781 19.2721 3.30949 18.981 3.35332 18.696L4.73832 9.696C4.81097 9.22359 5.0504 8.79282 5.41324 8.4817C5.77609 8.17059 6.23835 7.9997 6.71632 8H17.2843C17.7621 7.99994 18.2241 8.17094 18.5868 8.48203C18.9494 8.79312 19.1877 9.22376 19.2603 9.696Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
            btn_mobile.appendChild(icon_span);

            [btn_desktop, btn_mobile].forEach((btn) => {
              form.appendChild(btn);
            });

            wrapper.appendChild(form);
          }
          else {
            // Desktop button.
            a_desktop.classList.add('sold-out-button', 'sold-out-button-desktop');
            a_desktop.href = product_url;
            a_desktop.textContent = this.theme.translations.soldOut;

            // Mobile button.
            a_mobile.classList.add('sold-out-button', 'sold-out-button-mobile');
            if (quickShopMobileEnabled == false) a_mobile.classList.add('quick-shop-hidden');
            a_mobile.href = product_url;

            const icon_span = document.createElement('span');
            icon_span.innerHTML = `<svg viewBox="0 0 24 24" width="16" height="16" fill="none" xmlns="http://www.w3.org/2000/svg" class="quick-view-mobile-icon"><path d="M14.0003 5C14.0003 4.46957 13.7896 3.96086 13.4145 3.58579C13.0395 3.21071 12.5308 3 12.0003 3C11.4699 3 10.9612 3.21071 10.5861 3.58579C10.211 3.96086 10.0003 4.46957 10.0003 5M19.2603 9.696L20.6453 18.696C20.6891 18.9808 20.6709 19.2718 20.5917 19.5489C20.5126 19.8261 20.3746 20.0828 20.187 20.3016C19.9995 20.5204 19.7668 20.6961 19.505 20.8167C19.2433 20.9372 18.9585 20.9997 18.6703 21H5.33032C5.04195 21 4.75699 20.9377 4.49496 20.8173C4.23294 20.6969 4.00005 20.5212 3.81226 20.3024C3.62448 20.0836 3.48624 19.8267 3.40702 19.5494C3.32781 19.2721 3.30949 18.981 3.35332 18.696L4.73832 9.696C4.81097 9.22359 5.0504 8.79282 5.41324 8.4817C5.77609 8.17059 6.23835 7.9997 6.71632 8H17.2843C17.7621 7.99994 18.2241 8.17094 18.5868 8.48203C18.9494 8.79312 19.1877 9.22376 19.2603 9.696Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
            a_mobile.appendChild(icon_span);

            [a_desktop, a_mobile].forEach((a) => {
              wrapper.appendChild(a);
            });
          }

          if (cardImageBottomWrapper) cardImageBottomWrapper.appendChild(wrapper);

          // dispatch event after 500ms to let other scripts know that the quick add buttons have been added
          setTimeout(() => {
            document.dispatchEvent(new CustomEvent('quickadd:buttons:added'));
          }, 500);
        }
      )
    }
  }

  handleProductCardDisplay = () => {
    const gridViewItems = this.element.querySelectorAll('.grid-view-item');

    gridViewItems.forEach((gridViewItem) => {
      const isMobile = this.isMobile();
      // @ts-ignore
      const gridItemWidth = gridViewItem.offsetWidth;

      // Quick shop display
      const quickAddContainer = gridViewItem.querySelector('.product-card-image--bottom-wrapper');
      const quickAddWrapper = gridViewItem.querySelector('.quick-add-wrapper');
      if (quickAddContainer && quickAddWrapper) {
        if (gridItemWidth < 250 && !isMobile) {
          quickAddContainer.classList.add('quick-add-container--small');
          quickAddWrapper.classList.add('quick-add-wrapper--small');
        } else if (gridItemWidth > 250 || isMobile) {
          quickAddContainer.classList.remove('quick-add-container--small');
          quickAddWrapper.classList.remove('quick-add-wrapper--small');
        }
      }

      // Small grid item width layout toggle
      if (gridItemWidth < 250) {
        gridViewItem.classList.add('grid-view-item--small');
      } else {
        gridViewItem.classList.remove('grid-view-item--small');
      }
    });
  }

  handleShopNow = (e) => {
    e.preventDefault();
    this.theme.toggleRightDrawer('shop-now', true, { url: e.currentTarget.href });
  }

  _isLocalStorageSupported = () => {
    try {
      return typeof Storage != "undefined" && window.localStorage && window.sessionStorage ? true : false;
    } catch (e) {
      return false;
    }
  }

  paramStr = (arr) => {
    var parameters = [];
    for (var property in arr) {
      if (Object.prototype.hasOwnProperty.call(arr, property) && arr[property].length > 0) {
        parameters.push(encodeURI(arr[property]));
      }
    }

    return parameters.join(',');
  }

  // check if we're on mobile
  isMobile = () => {
    return window.matchMedia('(max-width: 1023px)').matches;
  }
}
